import { COUNTRIES } from '@config/constants'
import { dynamicImport, insertIf } from '@core/helpers'
import { ROUTES } from '@router'

const buybackRoutes = [
  {
    name: ROUTES.BUYBACK.DEVICE_FORM,
    path: '/buyback-funnel/device/:slug/:id',
    component: () => dynamicImport(import('./pages/StepDevice')),
  },
  {
    name: ROUTES.BUYBACK.OFFER,
    path: '/buyback-funnel/device/:slug/:id/offer/:offerId',
    component: () => dynamicImport(import('./pages/OfferStep')),
    props: true,
  },
  {
    name: ROUTES.BUYBACK.NO_OFFER,
    path: '/buyback-funnel/device/:slug/:id/no-offer',
    component: () => dynamicImport(import('./pages/NoOffer')),
  },
  {
    name: ROUTES.BUYBACK.BANK,
    path: '/buyback-funnel/device/:slug/:id/offer/:offerId/bank',
    component: () => dynamicImport(import('./pages/StepBank')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
  {
    name: ROUTES.BUYBACK.ADDRESS,
    path: '/buyback-funnel/device/:slug/:id/offer/:offerId/address',
    component: () => dynamicImport(import('./pages/StepAddress')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
  {
    name: ROUTES.BUYBACK.SHIPPING,
    path: '/buyback-funnel/device/:slug/:id/offer/:offerId/shipping',
    component: () => dynamicImport(import('./pages/StepShipping')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
  {
    name: ROUTES.BUYBACK.CONFIRMATION,
    path: '/buyback-funnel/confirmation/:id',
    component: () => dynamicImport(import('./pages/StepConfirmation')),
  },
]

const unrestrictedBuybackMerchantRoutes = [
  {
    name: ROUTES.BUYBACK.MERCHANT.UPDATE_CREDIT_CARD,
    path: '/buyback-merchant/update-credit-card',
    component: () => dynamicImport(import('./pages/Admin/UpdateCreditCard')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
  {
    name: ROUTES.BUYBACK.MERCHANT.UPDATE_CREDIT_CARD_SUCCESS,
    path: '/buyback-merchant/update-credit-card/success',
    component: () =>
      dynamicImport(import('./pages/Admin/UpdateCreditCardSuccess')),
  },
  {
    name: ROUTES.BUYBACK.MERCHANT.UPDATE_CREDIT_CARD_FAIL,
    path: '/buyback-merchant/update-credit-card/failure',
    component: () =>
      dynamicImport(import('./pages/Admin/UpdateCreditCardFailure')),
  },
  {
    name: ROUTES.BUYBACK.MERCHANT.ACH_UPDATE,
    path: '/buyback-merchant/update-ach',
    component: () => dynamicImport(import('./pages/Admin/UpdateAch')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
]

const restrictedBuybackMerchantRoutes = [
  {
    name: ROUTES.BUYBACK.MERCHANT.SEPA_UPDATE,
    path: '/buyback-merchant/update-sepa',
    component: () => dynamicImport(import('./pages/Admin/UpdateSepa')),
    meta: {
      auth: {
        required: true,
      },
    },
  },
  {
    name: ROUTES.BUYBACK.MERCHANT.SEPA_UPDATE_SUCCESS,
    path: '/buyback-merchant/update-sepa/success',
    component: () => dynamicImport(import('./pages/Admin/UpdateSepaSuccess')),
  },
  {
    name: ROUTES.BUYBACK.MERCHANT.SEPA_UPDATE_FAIL,
    path: '/buyback-merchant/update-sepa/failure',
    component: () => dynamicImport(import('./pages/Admin/UpdateSepaFailure')),
  },
]

export default ({ country }) => {
  const shouldAddBuybackRoutes = [
    COUNTRIES.DE,
    COUNTRIES.FR,
    COUNTRIES.US,
  ].includes(country)
  const shouldAddBuybackMerchantRoutes = [COUNTRIES.DE, COUNTRIES.FR].includes(
    country,
  )

  return [
    {
      path: '/dashboard/sourcing',
      name: ROUTES.DASHBOARD.SOURCING,
      meta: { rollout: false },
    },
    ...insertIf(shouldAddBuybackRoutes, buybackRoutes),
    ...unrestrictedBuybackMerchantRoutes,
    ...insertIf(
      shouldAddBuybackMerchantRoutes,
      restrictedBuybackMerchantRoutes,
    ),
  ]
}
